<template>
    <RightSidebar v-if="!appData.isMobile"></RightSidebar>
    <RightSidebarMobile v-else></RightSidebarMobile>
</template>
<script>
    import { reactive, toRefs, computed } from "vue";
    
    import { Constants } from "@/helpers/constants";
    import { appData, C } from "@/helpers/global";

    import RightSidebar from "@/layouts/_partials/RightSidebar.vue";
    import RightSidebarMobile from "@/layouts/_partials/RightSidebar.mobile.vue";

    import PreviewCard from "@/components/card/PreviewCard.vue";

    export default {
        components: {
            RightSidebar,
            RightSidebarMobile,
            PreviewCard,
        },
        unmounted() { this.bus.leave(); },
        setup() {
            const e = reactive({
                bus: appData.eventBus(Constants.Key.RightSidebar),
                type: computed(() => {     
                    return C.Int(e.bus.get(Constants.Key.RightSidebar)?.type);                     
                }),
            });
            return { ...toRefs(e) };
        },
    };
</script>